import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';

import PageHeader from '../components/global/PageHeader';
import UpdatePassword from 'components/account/UpdatePassword/UpdatePassword';
import { Container } from '@mui/material';

interface ResetPasswordParams {
  code: string;
}

const ResetPassword = () => {
  const { code } = useParams<ResetPasswordParams>();

  return (
    <Container maxWidth="xl" sx={{ p: 14, mb: 2 }}>
      <PageHeader title="Reset Password" />
      <Typography variant="h6">Please enter your new password below.</Typography>
      <UpdatePassword code={decodeURIComponent(code)} redirectToLogin={true} />
    </Container>
  );
};

export default ResetPassword;
